import { FC, useState } from 'react';
import { render } from 'storyblok-rich-text-react-renderer';
import { Addon, ShopContent } from '../../../types/cms_shared_types';
import { DefaultBottomBar } from '../BottomBar/DefaultBottomBar';
import { Step } from '../Step';
import { MusicNotes as MusicNotesIcon, Heart as HeartIcon } from 'phosphor-react';

interface LandingPageProps {
  isError: boolean;
  selectedAddons: Addon[];
  onSuccessButtonClick: () => void;
  onErrorButtonClick: () => void;
  cmsShopContent: ShopContent;
}

export const LandingPage: FC<LandingPageProps> = ({
  isError,
  selectedAddons,
  onSuccessButtonClick,
  onErrorButtonClick,
  cmsShopContent,
}) => {
  const [hasSoundtrackAddon] = useState(
    selectedAddons.some((addon) => addon.addonProvider.uuid === cmsShopContent.contactStep.soundtrackProvider.uuid),
  );

  return (
    <Step
      title={isError ? cmsShopContent.landingPageStep.errorTitle : cmsShopContent.landingPageStep.title}
      content={
        <div className="flex flex-col items-center max-w-3xl mx-auto text-center sm:w-9/12">
          <div className="w-48 h-1 bg-sami-green" />
          <div className="pt-10 sm:pt-8">
            <div className="mb-8 text-xl font-extrabold text-text-dark">
              <div>
                {isError
                  ? cmsShopContent.landingPageStep.errorDescriptionTitle
                  : cmsShopContent.landingPageStep.descriptionTitle}
              </div>
              {!isError && hasSoundtrackAddon && <div>{cmsShopContent.landingPageStep.soundtrackDescriptionTitle}</div>}
            </div>
            <div className="text-base font-normal text-text-dark opacity-70 ">
              {isError
                ? render(cmsShopContent.landingPageStep.errorDescriptionText)
                : render(cmsShopContent.landingPageStep.descriptionText)}
            </div>
          </div>
          <div className="flex flex-col items-center gap-5 mb-24">
            <HeartIcon weight="fill" className="text-lg text-sami-green" size={32} />
            <div className="text-base font-normal text-text-dark opacity-70">
              {render(cmsShopContent.landingPageStep.bottomText)}
            </div>
            <MusicNotesIcon weight="fill" className="text-lg text-sami-green" size={32} />
          </div>
        </div>
      }
      bottomBar={
        <DefaultBottomBar
          text={isError ? cmsShopContent.landingPageStep.errorButtonText : cmsShopContent.landingPageStep.buttonText}
          iconLeft={<></>}
          iconRight={<></>}
          continueButtonDisabled={false}
          onClick={isError ? onErrorButtonClick : onSuccessButtonClick}
          cmsShopContent={cmsShopContent}
        />
      }
    />
  );
};
